import { Button, Grid, Link, Theme, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPartnerName, getServicingOpCo } from '../../../app/store/combinedSelectors';
import { IconStateType } from '../../../types/type';
import { mapContactNumber } from '../../../utils/ContactNumber-Util';
import { getPrettyPhoneNumber } from '../../../utils/Utilities';
import ConfirmationHeader from '../../shared/ConfirmationHeader/ConfirmationHeader';

export default function PolicyNotFoundConfirmation() {
  const theme: Theme = useTheme();
  const headerContent = 'We could not find a matching policy.';
  const opco = useSelector(getServicingOpCo);
  const partnerName = useSelector(getPartnerName);
  const navigate = useNavigate();
  const contactNumber = mapContactNumber(opco, partnerName);

  function callUs() {
    window.open('tel:' + getPrettyPhoneNumber(contactNumber), '_blank');
  }

  function tryAgain() {
    navigate('/third-party-guest-type');
  }

  const introContent = (
    <Grid container>
      <Grid item xs={12}>
        <Typography sx={{ marginTop: '20px' }} variant="body1">
          Please try again, or give us a call at{' '}
          <Link component="button" underline="hover" variant="body1" onClick={() => callUs()}>
            {getPrettyPhoneNumber(contactNumber)}
          </Link>{' '}
          and we'll help you file a claim.
        </Typography>
      </Grid>
    </Grid>
  );

  /* If there are eligible services, the total number of stages will be more than 2 (Report and Complete are in the stages collection by default) */
  const content = (
    <>
      <Grid
        container
        sx={{
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
          margin: '0 auto',
        }}
      >
        <Grid item xs={12}>
          <ConfirmationHeader headerContent={headerContent} state={IconStateType.FAIL_STATE}></ConfirmationHeader>
        </Grid>

        <Grid sx={{ marginTop: '20px' }} item xs={12}>
          <Typography
            sx={{
              ...theme.custom.styles.serviceConfirmationHeader,
              marginTop: '0rem',
            }}
          >
            Next Steps
          </Typography>
        </Grid>
        {introContent}
      </Grid>

      <Grid
        container
        sx={{
          marginTop: '3em',
          marginLeft: '0 auto',
          marginRight: '0 auto',
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
        }}
      >
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Button
              sx={{
                ...theme.custom.styles.ctaNextButton,
                '&.MuiButtonBase-root:hover': {
                  bgcolor: theme.custom.colors.primaryButtonHoverColor,
                },
              }}
              onClick={tryAgain}
            >
              Try Again
            </Button>
            <Button
              sx={{
                ...theme.custom.styles.ctaSkipButton,
              }}
              onClick={callUs}
            >
              Call Us
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
  return <Box sx={{ width: '100%' }}>{content}</Box>;
}
